import React from "react";

import "../css/Divider.css"

function Divider(props) {
    return <hr style={props.style} className={'divider'}/>;
}

export default Divider;